import { render, staticRenderFns } from "./Attr.vue?vue&type=template&id=3865b851&scoped=true"
import script from "./Attr.vue?vue&type=script&lang=js"
export * from "./Attr.vue?vue&type=script&lang=js"
import style0 from "./Attr.vue?vue&type=style&index=0&id=3865b851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3865b851",
  null
  
)

export default component.exports